// @flow
import React from 'react';

import MemberItem from './MemberItem';
import type { Company } from '../../models/group_chats/Company';
import type { Supporter } from '../../models/supporters/Supporter';
import type { Staff } from '../../models/staffs/Staff';

type Props = {
  groupChatSize: number,
  company: Company,
  supporters: Array<Supporter>,
  staffs: Array<Staff>,
  companyImage: string,
};

export default function GroupChatMember(props: Props) {
  const { groupChatSize, company, supporters, staffs } = props;

  return (
    <div>
      <button
        type="button"
        data-toggle="modal"
        data-target="#myModal"
        className="btn-show-member"
      >
        <div className="float-right">
          <i className="fas fa-male" />{' '}
          <span className="group-chat-size">{groupChatSize}</span>
        </div>
      </button>
      <div className="modal fade modal-group-chat" id="myModal" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header modal-group-chat__member">
              <i className="fas fa-male float-left" />
              <h2 className="modal-title">
                <strong>メンバー紹介</strong>
              </h2>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="ml-20 mt-20">
                <strong>事業者</strong>
              </div>
              <MemberItem member={company} />
              {staffs.map((staff, index) => (
                <MemberItem member={staff} key={index} />
              ))}
              <div className="members">
                <div className="ml-20">
                  <strong>サポーター</strong>
                </div>
                {supporters.map((supporter, index) => (
                  <MemberItem member={supporter} key={index} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
